import { render, staticRenderFns } from "./SelVideo.vue?vue&type=template&id=761dbcb0&scoped=true"
import script from "./SelVideo.vue?vue&type=script&lang=js"
export * from "./SelVideo.vue?vue&type=script&lang=js"
import style0 from "./SelVideo.vue?vue&type=style&index=0&id=761dbcb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761dbcb0",
  null
  
)

export default component.exports